import { getEngine } from "./MultiFramePlaybackEngine";
import {
  MULTI_FRAME_FPS_MIN,
  MULTI_FRAME_FPS_MAX,
} from "./MultiFrameService";

const FPS_STEP = 1;
const FPS_STEP_FAST = 5;

const clampFps = (fps) =>
  Math.max(MULTI_FRAME_FPS_MIN, Math.min(MULTI_FRAME_FPS_MAX, fps));

// Returns true if the event was consumed (caller should preventDefault and
// stop further handling), false otherwise. The shortcuts are deliberately
// scoped to the active viewport — if it isn't multi-frame, nothing happens
// and the caller's normal handlers run.
export const handleMultiFrameShortcut = (event, activeViewportIndex) => {
  if (activeViewportIndex == null || activeViewportIndex < 0) return false;
  const engine = getEngine("viewport_" + activeViewportIndex);
  if (!engine) return false;

  // Space — Play / Pause
  if (event.keyCode === 32 || event.key === " " || event.code === "Space") {
    engine.togglePlay();
    return true;
  }

  // Arrow keys — step frames on a multi-frame viewport.
  // For multi-frame instances we override Up/Down and Left/Right because
  // the existing handlers call setImageIdIndex directly, which would
  // bypass the engine and leave its internal state stale. Engine.step()
  // pauses playback per spec.
  if (
    event.keyCode === 37 ||
    event.key === "ArrowLeft" ||
    event.keyCode === 38 ||
    event.key === "ArrowUp"
  ) {
    engine.step(-1);
    return true;
  }
  if (
    event.keyCode === 39 ||
    event.key === "ArrowRight" ||
    event.keyCode === 40 ||
    event.key === "ArrowDown"
  ) {
    engine.step(+1);
    return true;
  }

  // Home / End — jump to first / last frame
  if (event.keyCode === 36 || event.key === "Home") {
    if (engine.isPlaying) engine.pause();
    engine.seekTo(0);
    return true;
  }
  if (event.keyCode === 35 || event.key === "End") {
    if (engine.isPlaying) engine.pause();
    engine.seekTo(engine.totalFrames - 1);
    return true;
  }

  // + / − — FPS up / down (Shift gives ±5)
  const isPlus =
    event.key === "+" ||
    event.key === "=" ||
    event.keyCode === 187 ||
    event.keyCode === 107;
  const isMinus =
    event.key === "-" ||
    event.key === "_" ||
    event.keyCode === 189 ||
    event.keyCode === 109;
  if (isPlus) {
    const delta = event.shiftKey ? FPS_STEP_FAST : FPS_STEP;
    engine.setFps(clampFps(Math.round(engine.fps) + delta));
    return true;
  }
  if (isMinus) {
    const delta = event.shiftKey ? FPS_STEP_FAST : FPS_STEP;
    engine.setFps(clampFps(Math.round(engine.fps) - delta));
    return true;
  }

  return false;
};
